import React from 'react';
import CheckboxComponent from '../Components/CheckboxComponent'

/**
 * @param {[][]} props.component - 2d array  which contains for every row of a form the inside components
 * @param {setState} props.setComponents - hook method that handle components variable
 * @param {[][]} props.typeFields - 2d array which contains for every row of a form the types of the inside components  
 * @param {setState} props.setTypeFields - hook method that handle typeFields variable
 * @param {number} props.formRowIndex - index of examined row of a form
 * @param {number} props.indexComponent - index of checkbox component inside row with components
 * @param {setState} props.setClickedAddElement - hook method that handle clickedChangeElement variable
 * @returns component that represent checkbox inside a row of a form 
 */
const CheckboxDataComponent = (props) => {

    const {
        components,
        setComponents,
        typeFields,
        setTypeFields,
        formRowIndex,
        indexComponent,
        setClickedChangeElement
    }= props;

    // Function that removes checkbox component from components and typeFields variable
    const deleteComponent = () => {
        const tempComponents = [...components];
        tempComponents[formRowIndex].splice(indexComponent,1);
        setComponents(tempComponents);

        const tempTypeFields = [...typeFields];
        tempTypeFields[formRowIndex].splice(indexComponent,1);
        setTypeFields(tempTypeFields);
        setClickedChangeElement(true);
    } 

    return (
        <CheckboxComponent
            deleteComponent = {deleteComponent}
        />
    )

}

export default CheckboxDataComponent;